/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useAppStore } from '../..'

export const useDrawerStore = defineStore('DrawerStore', () => {
  const appStore = useAppStore()
  // State
  const initialized = ref(<boolean>false)
  const activeDrawer = ref<any | undefined>(undefined)
  const subDrawer = ref<any | undefined>(undefined)
  const showDrawer = ref<boolean>(false)
  const shouldScrollToSection = ref<boolean>(false)

  const canCloseDrawer = ref<boolean>(true)
  const canCloseSubDrawer = ref<boolean>(true)
  const showDrawerDialog = ref<boolean>(false)
  const showSubDrawerDialog = ref<boolean>(false)
  const showAlert = ref<boolean>(false)

  // Actions
  const init = async () => {
    // Your initialization logic
    initialized.value = true
  }

  const setActiveDrawer = async (drawer: any) => {
    activeDrawer.value = drawer
  }

  const setSubDrawer = async (drawer: any) => {
    if (showAlert.value === true) {
      showAlert.value = false
    }

    if (drawer != undefined) {
      subDrawer.value = drawer
      shouldScrollToSection.value = true
      const drawerContent = document.getElementById('drawerContent')
      drawerContent?.scroll(0, 0)
    } else if (drawer === undefined && canCloseSubDrawer.value === true) {
      subDrawer.value = drawer
      shouldScrollToSection.value = true
    } else {
      setShowDrawerDialog(true)
    }
  }

  const setShowDrawer = (toggle: boolean) => {
    showDrawer.value = toggle
  }

  const setCanCloseDrawer = (bool: boolean) => {
    appStore.setCanCloseApp(bool)
    canCloseDrawer.value = bool
  }

  const setShowDrawerDialog = (toggle: boolean) => {
    showDrawerDialog.value = toggle
  }

  const setShowSubDrawerDialog = (toggle: boolean) => {
    showSubDrawerDialog.value = toggle
  }

  const setCanCloseSubDrawer = (bool: boolean) => {
    shouldScrollToSection.value = true
    appStore.setCanCloseApp(bool)
    canCloseSubDrawer.value = bool
  }

  const closeSubDrawer = () => {
    setCanCloseSubDrawer(true)
    setSubDrawer(undefined)
    setShowSubDrawerDialog(false)
  }

  const setShowAlert = (toggle: boolean) => {
    showAlert.value = toggle
  }

  return {
    initialized,
    init,
    setActiveDrawer,
    activeDrawer,
    setSubDrawer,
    subDrawer,
    setShowDrawer,
    showDrawer,
    canCloseDrawer,
    setCanCloseDrawer,
    showDrawerDialog,
    setShowDrawerDialog,
    canCloseSubDrawer,
    setCanCloseSubDrawer,
    closeSubDrawer,
    showSubDrawerDialog,
    setShowSubDrawerDialog,
    showAlert,
    setShowAlert,
    shouldScrollToSection
  }
})
